import { TFunction } from "i18next";
import { z } from "zod";

export const getUpdateUserPasswordFormSchema = (t: TFunction) =>
  z.object({
    password: z
      .string()
      .min(3, { message: t("admin.users.errors.password-min") }),
    confirmPassword: z
      .string()
      .min(3, { message: t("admin.users.errors.password-min") }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: t("admin.users.errors.password-mismatch"),
  });

export type UpdateUserPasswordForm = z.infer<ReturnType<typeof getUpdateUserPasswordFormSchema>>;
